module.exports = __webpack_public_path__ + "img/stripe.5eb85456.svg";